import { Box, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import { MediaCard } from '../components/display/MediaCard';

const HomePage = ({ pages = [] }) => {
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(1);

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
    setPage(1); // Reset page number when tab changes
  };

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const mediaQuerySm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const mediaQueryMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const mediaQueryLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const mediaQueryXl = useMediaQuery((theme) => theme.breakpoints.up('xl'));
  const mediaQueryXxl = useMediaQuery((theme) => theme.breakpoints.up('xxl'));

  const calculateCardsPerRow = () => {
    if (mediaQueryXxl) return 5; // 6 cards per row for extra-extra-large screens
    if (mediaQueryXl) return 4; // 4 cards per row for extra-large screens
    if (mediaQueryLg) return 3; // 4 cards per row for large screens
    if (mediaQueryMd) return 2; // 3 cards per row for medium screens and larger
    if (mediaQuerySm) return 2; // 2 card per row for small screens
    return 1; // 1 card per row for extra small screens
  };

  const cardsPerRow = calculateCardsPerRow();
  const cardsPerPage = cardsPerRow * 1; // 1 rows per page

  // Create a 2D array with AppConfig.homeSubPages under each tab
  const tabsArray = [...new Set(pages.map((tab) => tab.product))];
  const organizedSubPages = tabsArray.map((tab) =>
    pages.filter((tabEntry) => tabEntry.product === tab)
  );

  // Get the cards based on the selected tab
  const filteredCards =
    tabValue === 0 ? pages : organizedSubPages[tabValue - 1];

  // Calculate pagination range
  const startIndex = (page - 1) * cardsPerPage;
  const endIndex = Math.min(startIndex + cardsPerPage, filteredCards.length);

  // Render individual cards for the current page
  const renderCards = () => {
    return filteredCards.slice(startIndex, endIndex).map((card, index) => (
      <Grid item xs={12 / cardsPerRow} key={index}>
        <MediaCard
          image={card.image}
          header={card.name}
          to={card.url}
          auth={card.auth}
        />
      </Grid>
    ));
  };

  return (
    <>
      {/* Cover image section */}
      <div style={{ position: 'relative', width: '100%', height: '60vh' }}>
        <img
          src='/resources/amg_one.jpg'
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'bottom',
          }}
          alt='Cover'
        />
        <div
          style={{
            position: 'absolute',
            top: '20%',
            left: '8%',
            textAlign: 'left',
            color: '#FFFFFF',
          }}
        >
          <Typography variant={'h1'}>Welcome to Delivery Promise</Typography>
          <Typography variant={'body1'}>We deliver what we promised</Typography>
        </div>
      </div>

      {/* Main content section */}
      <Box sx={{ p: 5 }}>
        <Typography variant={'h2'} sx={{ paddingBottom: 5 }}>
          {' '}
          Working Areas{' '}
        </Typography>

        {/* Tab bar */}
        <BasicTabs
          value={tabValue}
          handleChange={handleTabChange}
          tabs={['All', ...tabsArray]}
        />

        {/* Card grid */}
        <Grid container spacing={2} style={{ marginTop: 5 }}>
          {renderCards()}
        </Grid>

        {/* Pagination */}
        <Stack spacing={2} style={{ marginTop: 20 }}>
          <Pagination
            count={Math.ceil(filteredCards.length / cardsPerPage)}
            page={page}
            onChange={handlePageChange}
            color='primary'
          />
        </Stack>

        {/*  {/* News section 
        <Typography variant={"h4"} style={{ marginTop: 60 }}>
          Stay Updated
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 5 }}>
          {NewsContent.map((item, index) => (
            <NewsTable
              key={index}
              publisher={item.publisher}
              title={item.title}
              time={item.time}
              content={item.content}
            />
          ))}
        </Grid> */}
      </Box>
    </>
  );
};

function BasicTabs({ value, handleChange, tabs }) {
  return (
    <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='basic tabs example'
      >
        {tabs.map((label, index) => (
          <Tab key={index} label={label} />
        ))}
      </Tabs>
    </Box>
  );
}

export { HomePage };
